import { initTableSort, initTableSortSingle } from './_table-sort';
import { initDialogs } from './_dialogs';

initTableSort();
initDialogs();
initDeclarativeToggles();
initToggleRevert();

const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];

            if (!(node instanceof HTMLElement)) continue;

            // table.table-sort
            if (node.matches('table.table-sort')) {
                initTableSortSingle(<HTMLTableElement>node);
            }

            node.querySelectorAll('table.table-sort').forEach(table => {
                initTableSortSingle(<HTMLTableElement>table);
            });
        }
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

/**
 * Reverts a checkbox to its previous state when its HTMX request fails
 * (non-2xx response, network error, or timeout), so the visual toggle
 * never disagrees with what was actually persisted.
 */
function initToggleRevert() {
    const revert = (e: Event) => {
        const el = (e as CustomEvent).detail?.elt as HTMLElement | undefined;
        if (el instanceof HTMLInputElement && el.type === 'checkbox') {
            el.checked = !el.checked;
        }
    };

    document.body.addEventListener('htmx:responseError', revert);
    document.body.addEventListener('htmx:sendError', revert);
    document.body.addEventListener('htmx:timeout', revert);
}

function initDeclarativeToggles() {
    document.body.addEventListener('change', (e) => {
        const el = e.target as HTMLInputElement;
        if (el.type !== 'checkbox') return;

        if (el.dataset.toggles) {
            document.querySelectorAll(el.dataset.toggles).forEach(
                t => t.classList.toggle('hidden', !el.checked)
            );
        }

        if (el.dataset.disables) {
            document.querySelectorAll<HTMLInputElement | HTMLSelectElement>(el.dataset.disables).forEach(
                t => t.disabled = el.checked
            );
        }

        if (el.dataset.enables) {
            document.querySelectorAll<HTMLInputElement | HTMLSelectElement>(el.dataset.enables).forEach(
                t => t.disabled = !el.checked
            );
        }
    });
}